import * as r from 'ramda';
import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Switch, Route, withRouter, useLocation } from 'react-router-dom';

import { Routes, BaseRoutes } from 'constants/routes';
import { DOMAIN_API_KEY_MAPPING, DEFAULT_API_KEY } from 'constants/apiKeys';

import * as $nav from 'modules/navigation';
import * as $auth from 'modules/auth';

import { SignupPage } from 'view/pages/Signup';
import { SigninPage } from 'view/pages/Signin';
import { Dashboard } from 'view/pages/Dashboard';
import { DatasetsPage } from 'view/pages/Datasets';
import { ArtsPage } from 'view/pages/Arts';
import { WidgetsPage } from 'view/pages/Widgets';
import { ProfilePage } from 'view/pages/Profile';
import { ProfileEmailPage } from 'view/pages/ProfileEmail';
import { ProfilePublishPage } from 'view/pages/ProfilePublish';
import { VerifyEmailPage } from 'view/pages/VerifyEmail';
import { SuspenseWrapper } from 'view/pages/SuspenseWrapper';

const RoutesComponentsMapping = {
  [Routes.Dashboard]: Dashboard,
  [Routes.Datasets]: DatasetsPage,
  [Routes.Arts.Base]: ArtsPage,
  [Routes.Widgets.Base]: WidgetsPage,
  [Routes.Profile]: ProfilePage,
  [Routes.ProfileEmail]: ProfileEmailPage,
  [Routes.ProfilePublish]: ProfilePublishPage,
};

const RouterBase = ({ history, currentUserRoles }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    $nav.setHistory(history);
  }, [history]);

  useEffect(() => {
    const getApiKey = () => {
      const params = new URLSearchParams(location.search);

      const apiKeyUrlParam = params.get('apiKey');
      if (r.isNil(apiKeyUrlParam) || r.isEmpty(apiKeyUrlParam)) {
        const { hostname } = window.location;
        return DOMAIN_API_KEY_MAPPING[hostname] ?? DEFAULT_API_KEY;
      }

      return apiKeyUrlParam;
    };

    const apiKey = getApiKey();
    dispatch($auth.setApiKey(apiKey));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const availableRoutes = BaseRoutes.filter(
    ({ availableForRoles }) => !r.isEmpty(r.intersection(availableForRoles, currentUserRoles ?? []))
  );

  return (
    <SuspenseWrapper>
      <Switch>
        <Route path={Routes.Signup} component={SignupPage} />
        <Route path={Routes.Signin} component={SigninPage} />
        <Route path={Routes.VerifyEmail} component={VerifyEmailPage} />

        {availableRoutes.map(({ path }) => (
          <Route key={path} path={path} component={RoutesComponentsMapping[path]} />
        ))}

        <Route path="*" component={SigninPage} />
      </Switch>
    </SuspenseWrapper>
  );
};

export const Router = r.compose(
  withRouter,
  connect(
    r.applySpec({
      currentUserRoles: $auth.getCurrentUserRoles,
    })
  )
)(RouterBase);
